module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fj7es"))).then(() => module.bundle.root('ikE14'));